// We haven't added icon's computed property because it makes this mixins coupled with UI
export const togglePasswordVisibility = {
  data () {
    return {
      passwordFieldType: 'password',
      passwordConfirmationFieldType: 'password'
    }
  },
  methods: {
    togglePasswordVisibility () {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },

    togglePasswordConfirmationVisibility () {
      this.passwordConfirmationFieldType = this.passwordConfirmationFieldType === 'password' ? 'text' : 'password'
    }
  }
}

export const _ = null
